import React, { useState } from "react";
import { useGov } from "@/hooks/governance";
import { formatAdaBigCount, formatBigCount } from "@/lib/format";
import { Badge, HashCell } from "@/components/primitives";
import { Table } from "@/components/Table";
import { GovPageShell, GovError, GovPager, useGovNav } from "@/components/governance/GovShell";

const PAGE_SIZE = 25;

const statusTone = (r) => (r.special ? "info" : r.retired ? "default" : r.expired ? "warn" : "success");

const columns = (navigate) => [
  {
    key: "drep",
    label: "DRep",
    render: (r) =>
      r.special ? (
        <span className="text-foreground">{(r.drep_id || "").replace(/_/g, " ")}</span>
      ) : (
        <button
          type="button"
          data-testid={`drep-row-${r.drep_id}`}
          onClick={() => navigate(`/governance/dreps/${r.drep_id}`)}
          className="text-left text-foreground hover:text-primary underline decoration-dotted decoration-border underline-offset-2 transition-colors mono text-[12px]"
        >
          {(r.drep_id || "").slice(0, 16)}…{(r.drep_id || "").slice(-6)}
        </button>
      ),
  },
  { key: "status", label: "Status", render: (r) => <Badge tone={statusTone(r)}>{r.special ? "special" : r.expired ? "expired" : r.status}</Badge> },
  { key: "power", label: "Voting Power", align: "right", render: (r) => <span className="text-foreground">{formatAdaBigCount(r.voting_power)} ₳</span> },
  { key: "delegators", label: "Delegators", align: "right", render: (r) => <span className="text-muted-foreground">{formatBigCount(r.delegators_count)}</span> },
  { key: "until", label: "Active Until", align: "right", render: (r) => <span className="text-muted-foreground">{r.active_until ? `epoch ${r.active_until}` : "—"}</span> },
];

export const DrepsList = ({ meta }) => {
  const navigate = useGovNav();
  const [page, setPage] = useState(1);
  const { data, error, loading, refetch } = useGov("/governance/dreps", { params: { count: PAGE_SIZE, page, sort: "voting_power", order: "desc" } });
  const rows = Array.isArray(data) ? data : [];
  return (
    <GovPageShell crumbs={meta.crumbs} title={meta.title} subtitle="Delegated representatives ranked by on-chain voting power.">
      {error ? (
        <GovError error={error} onRetry={refetch} />
      ) : (
        <>
          <Table columns={columns(navigate)} rows={rows} loading={loading} skeletonRows={10} empty="No DReps found." />
          <GovPager page={page} onPage={setPage} hasNext={rows.length === PAGE_SIZE} loading={loading} />
        </>
      )}
    </GovPageShell>
  );
};
